import { render, staticRenderFns } from "./help-button.vue?vue&type=template&id=1975a9c6&scoped=true"
import script from "./help-button.vue?vue&type=script&lang=js"
export * from "./help-button.vue?vue&type=script&lang=js"
import style0 from "./help-button.vue?vue&type=style&index=0&id=1975a9c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1975a9c6",
  null
  
)

export default component.exports